import type { SVGProps } from 'react';

const SvgMoon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 20c-4.41 0-8-3.59-8-8 0-3.33 2.01-6.25 5.12-7.46a1.01 1.01 0 0 1 1.3 1.3A6 6 0 0 0 10.01 8c0 3.31 2.69 6 6 6a6 6 0 0 0 2.16-.41c.37-.14.79-.06 1.07.23.28.28.37.7.23 1.07a7.95 7.95 0 0 1-7.46 5.12zM8.01 7.51A5.96 5.96 0 0 0 6 12c0 3.31 2.69 6 6 6 1.76 0 3.37-.75 4.49-2.01-.16 0-.32.01-.49.01-4.41 0-8-3.59-8-8 0-.16 0-.33.01-.49"
    />
  </svg>
);
export default SvgMoon;
